import * as dicomParser from 'dicom-parser';

export const fromRSArrayBufferResponse = (arrayBufferResponse) => {

  const StartArray = new Uint8Array([13, 10, 13, 10]);
  const EndArray = new Uint8Array([10, 13]);

  const byteArray = new Uint8Array(arrayBufferResponse);
  const length = byteArray.length;

  let StartExtraction = 0;
  let EndExtraction = 0;
  let PostionArrayFind = 0;

  // Find StartArray in byteArray
  for (let k = 0; k < 800; k++) {
    if (byteArray[k] === StartArray[PostionArrayFind]) {
      if (StartArray.length - 1 === PostionArrayFind) {
        StartExtraction = k + 1;
        break;
      } else {
        PostionArrayFind += 1;
      }
    } else {
      PostionArrayFind = 0;
    }
  }

  // Find EndArray in byteArray, inverse
  PostionArrayFind = 0;
  for (let k = 2; k < 100; k++) {
    let j = length - k;
    if (byteArray[j] === EndArray[PostionArrayFind]) {
      if (EndArray.length - 1 === PostionArrayFind) {
        EndExtraction = -k;
        break;
      } else {
        PostionArrayFind += 1;
      }
    } else {
      PostionArrayFind = 0;
    }
  }

  let arr = byteArray.slice(StartExtraction, EndExtraction);

  return dicomParser.parseDicom(arr);
};

const getLib3dDataSet = {
  fromRSArrayBufferResponse
};

export default getLib3dDataSet;
